<template>
  <div id="circleDetailItemComp">
    <div class="title">
      <i class="icon icon-wen"></i>
      <div class="name text-ellipsis">{{detail.name}}</div>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_zan_01.png')" />
          <span>{{detail.heat}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
          <span>{{detail.answer}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_star_01.png')" />
          <span>{{detail.followers}}</span>
        </div>
      </div>
      <div class="date">{{detail.createTime | formatDate('yyyy年MM月dd日')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'circleDetailItemComp',
  props: {
    detail: {
      type: Object,
      default () {
        return {};
      }
    }
  }
};
</script>

<style lang="less" scoped>
#circleDetailItemComp {
  min-height: 170px;
  padding: 32px 20px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title {
    display: flex;
    align-items: center;
    .icon {
      width: 34px;
      height: 34px;
      margin-right: 20px;
      &.icon-wen{
        background-image: url("~@/assets/images/issue/icon_wen_02.png");
      }
    }
    .name {
      font-size: 26px;
      font-weight: bold;
      color: #333444;
      line-height: 36px;
    }
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      &,.item{
        display: flex;
        align-items: center;
      }
      .item {
        margin-right: 20px;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
    .date {
      font-size: 24px;
      color: #999AAA;
    }
  }
}
</style>